import { Route, Routes, useLocation } from "react-router";
import EditingItems from "./EditingItems";
import EditingTextbooks from "./EditingTextbooks";
import { Link } from "react-router-dom";
import { Button, Col, Row } from "react-bootstrap";
import EditingTextbook from "./EditingTextbook";
import FAIcon from "components/General/FAIcon";
import EditingUnit from "./EditingUnit";
import EditingTopic from "./EditingTopic";
import EditingSection from "./EditingSection";
import { useState } from "react";
import ImageLibrary from "./ImageLibrary";
import EditingReview from "./Reviews/EditingReview";
import EditingReviewHome from "./Reviews/EditingReviewHome";
import EditingReviewGroups from "./Reviews/EditingReviewGroups";
import EditingReviewGroup from "./Reviews/EditingReviewGroup";
import EditingBlocks from "./Reviews/EditingBlocks";
import EditingBlock from "./Reviews/EditingBlock";

const routes = {
    home: "/editing",
    curriculum: "/editing/curriculum/",
    book: "/editing/curriculum/book/:bookId",
    unit: "/editing/curriculum/book/:bookId/unit/:unitId",
    topic: "/editing/curriculum/book/:bookId/unit/:unitId/topic/:topicId",
    section: "/editing/curriculum/book/:bookId/unit/:unitId/topic/:topicId/section/:sectionId",
    blocks: "/editing/review/blocks",
    block: "/editing/review/blocks/:blockId",
    blockReviewGroup: "/editing/review/blocks/:blockId/group/:groupId",
    reviewHome: "/editing/review/",
    reviewGroups: "/editing/review/group/",
    reviewGroup: "/editing/review/group/:groupId",
    reviews: "/editing/review/reviews",
}

const routeToRegex = (route: string) => new RegExp("^" + route.replace(/:[^/]+/g, "([a-zA-Z0-9-]+)") + "/?$")

const headersByRoute = [
  { pattern: routeToRegex(routes.home), header: "Content Editing" },
  { pattern: routeToRegex(routes.curriculum), header: "Content Editing" },
  { pattern: routeToRegex(routes.book), header: "Book Editing" },
  { pattern: routeToRegex(routes.unit), header: "Unit Editing" },
  { pattern: routeToRegex(routes.topic), header: "Topic Editing" },
  { pattern: routeToRegex(routes.section), header: "Section Editing" },
  { pattern: routeToRegex(routes.reviewHome), header: "Review Editing Home" },
  { pattern: routeToRegex(routes.blocks), header: "Blocks" },
  { pattern: routeToRegex(routes.block), header: "Block Editing" },
  { pattern: routeToRegex(routes.blockReviewGroup), header: "Review Group Editing" },
  { pattern: routeToRegex(routes.reviewGroups), header: "Review Groups" },
  { pattern: routeToRegex(routes.reviewGroup), header: "Review Group Editing" },
  { pattern: routeToRegex(routes.reviews), header: "Reviews Editing" },
]

export default function EditingDashboard() {
    const location = useLocation()
    const pathname = location.pathname

    const shouldGobackTwoLevel = [routes.curriculum, routes.book, routes.unit, routes.topic, routes.blockReviewGroup].some(route => routeToRegex(route).test(pathname))
    const parentUrl = new URL(shouldGobackTwoLevel ? ".." : ".", window.origin + pathname.replace(/\/$/, "")) // move only one step back for review routes

    const [modal, setModal] = useState<string>(null)

    function getTitle() {
        for (const {pattern, header} of headersByRoute) {
            if (pattern.test(pathname)) return header
        }
        return "Content Editing"
    }

    return <>
        <Row>
            <Col className="mt-3">
                <Link to={parentUrl.pathname.includes("editing") ? parentUrl : "/editing"}>
                    <span><FAIcon iconName="arrow-up" /> Go Up a Level</span>
                </Link>
            </Col>

            <Col>
                <h2 className="my-3">{getTitle()}</h2>
            </Col>

            <Col>
                <Button className="mt-3" onClick={() => setModal("imageLibrary")}>Image Library</Button>
            </Col>
        </Row>
        <Routes>
            <Route path="/" element={<EditingItems />} />
            <Route path="/curriculum/" element={<EditingTextbooks />} />
            <Route path="/curriculum/book/:bookId" element={<EditingTextbook />} />
            <Route path="/curriculum/book/:bookId/unit/:unitId" element={<EditingUnit />} />
            <Route path="/curriculum/book/:bookId/unit/:unitId/topic/:topicId" element={<EditingTopic />} />
            <Route path="/curriculum/book/:bookId/unit/:unitId/topic/:topicId/section/:sectionId" element={<EditingSection />} />
            <Route path="/review/blocks" element={<EditingBlocks />} />
            <Route path="/review/blocks/:blockId" element={<EditingBlock />} />
            <Route path="/review/blocks/:blockId/group/:groupId" element={<EditingReviewGroup />} />
            <Route path="/review/" element={<EditingReviewHome />} />
            <Route path="/review/group" element={<EditingReviewGroups />} />
            <Route path="/review/group/:groupId" element={<EditingReviewGroup />} />
            <Route path="/review/reviews" element={<EditingReview />} />
        </Routes>

        <ImageLibrary modal={modal} setModal={setModal} />
    </>
}
